import { FAQLayout } from "@features/layout/FAQ";

export const FAQPage = () => {
  return <FAQLayout />;
};
